import analyticsMixin from "@/mixins/analytics-mixin";
import store from "@/store";
import { storeMutations } from "@/constants/store-mutations";

export async function afterEach(to, from) {
    store.commit(storeMutations.UPDATE_LAST_PAGE_VISITED, to.name);

    // digital consumer fmg session logging to snowflake
    analyticsMixin.methods.pushFmgSessionData();

    // Push page view to GA
    analyticsMixin.methods.pushPageViewToGA();

    // Push experiments to Data Layer
    analyticsMixin.methods.pushExperimentsToDataLayer();

    // Push current order status to Data Layer
    analyticsMixin.methods.pushOrderToDataLayer();
}
